<t4-header icon="glyphicon-stats" title="{{'turbo.OneWay.LocationKPI.Headline' |translate : 'Location statistics' }}"></t4-header>
<t4-container>
  <t4-data-table apiMethod="OneWay/GetLocationKPIs" [parameters]="{month:today.month(), year:today.year()}" headline="{{ 'turbo.OneWay.LocationKPI.Headline' | translate : 'Location statistics' }}" matSort></t4-data-table>
</t4-container>
